import { render, staticRenderFns } from "./InsolvencyTab.vue?vue&type=template&id=468e6b40&scoped=true&"
import script from "./InsolvencyTab.vue?vue&type=script&lang=js&"
export * from "./InsolvencyTab.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "468e6b40",
  null
  
)

export default component.exports